

import { Control } from 'react-hook-form';
import { ProfileFormValues } from '../ProfileFormSchema';
import { BeltSelector } from './BeltSelector';
import { CustomBeltField } from './CustomBeltField';
import { StripesSelector } from './StripesSelector';

type BeltRankFieldsProps = {
  control: Control<ProfileFormValues>;
  showCustomBelt: boolean;
  setShowCustomBelt: (show: boolean) => void;
};

export function BeltRankFields({ 
  control, 
  showCustomBelt, 
  setShowCustomBelt 
}: BeltRankFieldsProps) {
  return (
    <>
      <BeltSelector 
        control={control} 
        setShowCustomBelt={setShowCustomBelt} 
      />
      
      <CustomBeltField 
        control={control} 
        show={showCustomBelt} 
      />
      
      <StripesSelector control={control} />
    </>
  );
}
